import { applyStyle } from '../css';
export function createPageHeader(opts) {
    const header = document.createElement('header');
    header.classList.add('pr-page-header');
    applyStyle(header, {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 'var(--sp-4)',
        padding: 'var(--sp-6) 0 var(--sp-5)',
        borderBottom: '1px solid var(--border-subtle)',
        marginBottom: 'var(--sp-5)',
        flexWrap: 'wrap',
    });
    const left = document.createElement('div');
    applyStyle(left, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)', flex: '1', minWidth: '0' });
    const titleEl = document.createElement('h1');
    titleEl.classList.add('pr-page-title');
    applyStyle(titleEl, {
        margin: '0',
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic',
        fontWeight: '500',
        fontSize: 'var(--fs-display-xl)',
        lineHeight: 'var(--lh-tight)',
        color: 'var(--text-primary)',
        letterSpacing: '-0.01em',
    });
    titleEl.textContent = opts.title;
    if (opts.highlight) {
        titleEl.append(' ');
        const hi = document.createElement('span');
        hi.textContent = opts.highlight;
        applyStyle(hi, {
            color: 'var(--accent)',
        });
        titleEl.append(hi);
    }
    left.append(titleEl);
    if (opts.subtitle) {
        const sub = document.createElement('p');
        sub.textContent = opts.subtitle;
        applyStyle(sub, {
            margin: '0',
            fontSize: 'var(--fs-body)',
            color: 'var(--text-secondary)',
            maxWidth: '720px',
        });
        left.append(sub);
    }
    header.append(left);
    if (opts.rightSlot)
        header.append(opts.rightSlot);
    return header;
}
